module.exports = __webpack_public_path__ + "static/media/warehousing-default.1f2c3be1.svg";